// Version of PCT IG supported by this Client Reference Implementation (RI)
export const CLIENT_VERSION = '2.0.1';